import { Controller } from "@hotwired/stimulus";

/**
 * ptz-housing-toggle (#728)
 *
 * Bascule locale Maison / Collectif du bloc « PTZ et budget MAX ».
 * Les deux tableaux sont déjà peuplés par `remote-bind` ; on n'affiche que
 * celui du type choisi. Aucun champ de formulaire : le choix n'est ni
 * sérialisé, ni persisté, ni envoyé à api-sync.
 *
 * Défaut : Collectif (`data-ptz-housing-toggle-selected-value`, sinon
 * `collectif`).
 */
export default class extends Controller {
  static targets = ["option", "panel"];
  static values = { selected: { type: String, default: "collectif" } };

  connect() {
    this.show(this.selectedValue || "collectif");
  }

  select(event) {
    event.preventDefault();
    const housing = event.currentTarget && event.currentTarget.dataset
      ? event.currentTarget.dataset.housing
      : null;
    if (!housing) return;
    this.selectedValue = housing;
    this.show(housing);
  }

  show(housing) {
    this.optionTargets.forEach((el) => {
      const active = el.dataset.housing === housing;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-pressed", active ? "true" : "false");
    });
    this.panelTargets.forEach((el) => {
      el.classList.toggle("d-none", el.dataset.housing !== housing);
    });
  }
}
